import { render, staticRenderFns } from "./UnitOfMeasurement.vue?vue&type=template&id=c1efcb7e&"
import script from "./UnitOfMeasurement.vue?vue&type=script&lang=js&"
export * from "./UnitOfMeasurement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports